// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectTokenVerifyMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_TOKEN_VERIFY_RESPONSE);
        this.IsExpired = false;
        this.Login = null;
    }
}
